import { dateOnlySchema } from '@debts-system/contracts';
import { createFileRoute } from '@tanstack/react-router';
import { StatementPage } from '@/features/debts/statement-page.js';

/** A period handed over by the كشف العميل report; anything else is ignored. */
function periodParam(value: unknown): string | undefined {
  return dateOnlySchema.safeParse(value).success ? (value as string) : undefined;
}

export const Route = createFileRoute('/_app/accounts/$id')({
  validateSearch: (search: Record<string, unknown>): { from?: string; to?: string } => ({
    from: periodParam(search['from']),
    to: periodParam(search['to']),
  }),
  component: StatementRoute,
});

function StatementRoute() {
  const { id } = Route.useParams();
  const { from, to } = Route.useSearch();
  // Keyed by account so another account's statement starts from its own last page.
  return <StatementPage key={id} accountId={id} initialFrom={from} initialTo={to} />;
}
